import { useTheme } from '@emotion/react';
import type React from 'react';

import { ResponsiveNavigator } from './responsive-nav';

export const RootNavigator: React.FC = () => {
  const { navigatorTheme } = useTheme();

  return <ResponsiveNavigator theme={navigatorTheme} />;
};
